import {
    GET_CURRENT_CATEGORY
} from './constants';

const initialState = {
    currentCategory: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_CATEGORY: {
            return {
                ...state,
                currentCategory: action.payload,
            };
        }
        default:
            return state;
    }
};

